import React, { useState } from "react";
//#region types
import { TranslationKeys } from "translations";
import { CommentItem, CommentsProps } from "models/propTypes/commentViewPropTypes";
//#endregion
//#region components
import ShowMoreButton from "./showMoreButton";
import Comment from "./comment";
import { Grid, Skeleton } from "@mui/material";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const Comments: React.FC<CommentsProps> = (props) => {
  const {
    viewCountIncreaseBy = 4,
    comments,
    parentId,
    defaultViewCount,
    loading,
    onShowMoreClick,
    hideViewMore,
    showAllComments,
  } = props;
  const [viewCount, setViewCount] = useState<number>(defaultViewCount ?? viewCountIncreaseBy);

  const showMore = () => {
    onShowMoreClick ? onShowMoreClick() : setViewCount(viewCount + viewCountIncreaseBy);
  };

  const sortingFuncNewestFirst = (a: CommentItem, b: CommentItem) =>
    new Date(b.date).getTime() - new Date(a.date).getTime();
  const sortingFuncOldestFirst = (a: CommentItem, b: CommentItem) =>
    new Date(a.date).getTime() - new Date(b.date).getTime();
  const sortingFunc = props.oldestFirst ? sortingFuncOldestFirst : sortingFuncNewestFirst;

  const indexFirstCommentToShow = props.oldestFirst ? -viewCount : undefined;
  const indexLastCommentToShow = props.oldestFirst ? undefined : viewCount;

  let commentItemsToShow = comments
    ?.filter((c) => !!c.message || (c.attachments && c.attachments.length > 0))
    .sort(sortingFunc);
  if (!showAllComments) {
    commentItemsToShow = comments?.slice(indexFirstCommentToShow, indexLastCommentToShow);
  }

  const displayShowMoreButton = (comments?.length ?? 0) > viewCount && !hideViewMore && !showAllComments;

  if (loading)
    return (
      <Grid item container xs={12} className={cssExports.commentsList}>
        <Skeleton width="100%" height="60px" />
      </Grid>
    );

  if (!comments) return <></>;

  const showMoreOnBottom = !props.oldestFirst && displayShowMoreButton;

  return (
    <>
      {props.oldestFirst && displayShowMoreButton ? (
        <Grid item container justifyContent="center">
          <ShowMoreButton onClick={showMore} expandDirectionUp>
            {props.viewCountIncreaseButtonText ??
              LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.ViewOlder)}
          </ShowMoreButton>
        </Grid>
      ) : null}
      <Grid item container xs={12} className={cssExports.commentsList} marginBottom={showMoreOnBottom ? 2 : undefined}>
        {!commentItemsToShow?.length
          ? null
          : commentItemsToShow.map((item, index) => {
              return (
                <Comment
                  parentId={parentId}
                  key={index}
                  id={item.id}
                  isWint={item.isWint}
                  from={item.from}
                  message={item.message}
                  subject={item.subject}
                  footer={item.footer}
                  date={item.date}
                  attachments={item.attachments}
                  isAutomatic={item.isAutomatic}
                  isPlaceholderMessage={item.isPlaceholderMessage}
                  getImageContent={props.getImageContent}
                  onFileClick={props.onFileClick}
                >
                  {item.children}
                </Comment>
              );
            })}
      </Grid>
      {!props.oldestFirst && displayShowMoreButton ? (
        <Grid item container justifyContent="center">
          <ShowMoreButton onClick={showMore}>
            {props.viewCountIncreaseButtonText ??
              LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.ViewOlder)}
          </ShowMoreButton>
        </Grid>
      ) : null}
    </>
  );
};

export default Comments;
